<mat-card class="cardWithShadow theme-card">
    <mat-card-header>
        <mat-card-title>Detalle Factura Folio N°{{ data?.folio }}</mat-card-title>
        <button mat-icon-button (click)="closeDialog()" style="position: absolute; right: 10px">
            <mat-icon>close</mat-icon>
        </button>
        <!--<hr class="linea-separadora">-->
    </mat-card-header>

    <mat-divider style="margin-top: 20px;"></mat-divider>

    <mat-card-content>

        <div class="row">
            <div class="col-md-6"> 
              <table>
                <tr>
                    <td><h4>N°Factura:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="data?.invoiceId">{{ data?.folio }}</h4>
                        <h4 class="detalle" *ngIf="!data?.invoiceId">No hay Informacion</h4>
                    </td>
                </tr>
                <tr>
                    <td><h4>Nombre Cliente:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="data?.clientName">{{ data?.clientName }}</h4>
                        <h4 class="detalle" *ngIf="!data?.clientName">No hay Informacion</h4>
                    </td>
                </tr>
                <tr>
                    <td><h4>Rut Cliente:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="data?.clientRut">{{ data?.clientRut }}</h4>
                        <h4 class="detalle" *ngIf="!data?.clientRut">No hay Informacion</h4>
                    </td>
                </tr>
                <tr>
                    <td><h4>Monto Total:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="data?.totalAmount">{{ data?.totalAmount | currency:'CLP' }}</h4>
                        <h4 class="detalle" *ngIf="!data?.totalAmount">No hay Informacion</h4>
                    </td>
                </tr>
                <tr>
                    <td><h4>IVA:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="data?.ivaAmount">{{ data?.ivaAmount | currency:'CLP' }}</h4>
                        <h4 class="detalle" *ngIf="!data?.ivaAmount">No hay Informacion</h4>
                    </td>
                </tr>
                <tr>
                    <td><h4>Fecha:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="data?.fechaDocto">{{ data?.fechaDocto | date : "dd/MM/yyyy" }}</h4>
                        <h4 class="detalle" *ngIf="!data?.fechaDocto">No hay Informacion</h4>
                    </td>
                </tr>
                <tr>
                    <td><h4>Existe Orden:</h4></td>
                    <td *ngIf="data.hasBuyOrder" style="cursor: pointer;" (click)="mostrarDatosOperacion()">
                        <i-tabler
                        name="circle-check-filled"
                        class="icon-20"
                        style="color: mediumspringgreen"
                      ></i-tabler>
                      Ver Detalles
                    </td>
                    <td *ngIf="!data.hasBuyOrder">
                        <i-tabler
                        name="circle-x-filled"
                        class="icon-20"
                        style="color: red"
                      ></i-tabler>
                    </td>
                </tr>
                <tr>
                    <td><h4>Cedible:</h4></td>
                    <td>
                        <h4 class="detalle" *ngIf="data?.isCedible">
                            <i-tabler
                            name="circle-check-filled"
                            class="icon-20"
                            style="color: mediumspringgreen"
                          ></i-tabler>
                        </h4>
                        <h4 class="detalle" *ngIf="!data?.isCedible">
                            <i-tabler
                            name="circle-x-filled"
                            class="icon-20"
                            style="color: red"
                          ></i-tabler>
                        </h4>
                    </td>
                </tr>
              </table>
            </div>
            <div class="col-md-6" *ngIf="this.hasOrder == true " @fadeIn>
                <h2 style="text-decoration: underline;">Detalle Orden</h2>

                <table>
                    <tr>
                        <td><h4>Codigo:</h4></td>
                        <td>
                            <h4 class="detalle" *ngIf="data?.code">{{ data?.code }}</h4>
                            <h4 class="detalle" *ngIf="!data?.code">No hay Informacion</h4>
                        </td>
                    </tr>
                    <tr>
                        <td><h4>Fecha de Emision:</h4></td>
                        <td>
                            <h4 class="detalle" *ngIf="data?.fechaEmision">{{ data?.fechaEmision | date : "dd/MM/yyyy" }}</h4>
                            <h4 class="detalle" *ngIf="!data?.fechaEmision">No hay Informacion</h4>
                        </td>
                    </tr>
                    <tr>
                        <td><h4>Monto:</h4></td>
                        <td>
                            <h4 class="detalle" *ngIf="data?.amount">{{ data?.amount | currency:'CLP':'symbol' }}</h4>
                            <h4 class="detalle" *ngIf="!data?.amount">No hay Informacion</h4>
                        </td>
                    </tr>
                    <tr>
                        <td><h4>SIGFE:</h4></td>
                        <td>
                            <h4 class="detalle" *ngIf="data?.sigfe">{{ data?.sigfe ? 'Activo' :'Inactivo' }}</h4>
                            <h4 class="detalle" *ngIf="!data?.sigfe">No hay Informacion</h4>
                        </td>
                    </tr>
                    <tr>
                        <td><h4>Plazo:</h4></td>
                        <td>
                            <h4 class="detalle" *ngIf="data?.plazo">{{ data?.plazo + ' dias' }}</h4>
                            <h4 class="detalle" *ngIf="!data?.plazo">No hay Informacion</h4>
                        </td>
                    </tr>
                    <tr>
                        <td><h4>Documento URL:</h4></td>
                        <td>
                            <h4 class="detalle" *ngIf="data?.documentUri">{{ data?.documentUri }}</h4>
                            <h4 class="detalle" *ngIf="data?.documentUri==''">No hay Informacion</h4>
                        </td>
                    </tr>
                </table>

            </div>
        </div>

    </mat-card-content>
</mat-card>